import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

const initialAbility: any = [];
export const AbilityContext = createContext(initialAbility);
const Can = createContextualCan(AbilityContext.Consumer);
export default Can;
